import { saveJobVersionHistory } from "../api/apiCall";

export const shiftTypeRates = (shiftType: any, newName: any) => {
  switch (shiftType) {
    case 0:
      return newName?.basicRates?.dayRate ?? 0;
    case 1:
      return newName?.basicRates?.nightRate ?? 0;
    case 2:
      return newName?.basicRates?.weekendRate ?? 0;
    default:
      return null;
  }
};

export const createEmptyWorker = (workerId: number, jobId: number, orderNumber: number) => ({
  id: workerId,
  userId: null,
  jobId,
  fullName: null,
  pts: null,
  phoneNumber: null,
  postCode: null,
  hourlyRate: 0,
  colorIdentifier: null,
  s: 0,
  t: 0,
  notes: null,
  d: false,
  f: false,
  h_Color: 0,
  h: 0,
  paid: false,
  paymentMethod: null,
  paymentMethodId: null,
  riskAssessments: 0,
  orderNumber,
  workRole: null,
});

export const updateRows = (colId: any, field: any, newValue: any, workers: any[]) => {
  return workers.map((row: any) =>
    row.id === colId ? { ...row, [field]: newValue } : row
  );
};

export const saveChangesHistory = async (token: string | undefined, id: string, formattedDiffs: any) => {
  const changesJsonToString = JSON.stringify(formattedDiffs);
  await saveJobVersionHistory(token, id, changesJsonToString);
};

export const getBackColor = (color: any) => {
  switch (color) {
    case "red":
      return "red";
    case "lightgreen":
      return "lightgreen";
    case "yellow":
      return "yellow";
    case "#f28519":
      return "ember"
    case "#0096FF":
      return "blue";
    case "pink":
      return "pink"
    case "black":
      return "black"
  }
};
